'use client'
import React, { useState, useContext } from 'react'
import { Button, Spinner, Textarea } from '@nextui-org/react'
import CardDefault from '../cards/CardDefault'
import { ThreadAPI } from '../../../data/socialize';
import { UserContext } from '../../../contexts/UserContext';
import { Route } from '../../../routers/routes';
import LoginSuggestion from '../authentication/LoginSuggestion';
import CardContainer from '../cards/CardContainer';

export default function ThreadCreateForm(props) {
  const { 
    entityId, 
    onSuccess,
    appName,
    modelName,
    createLabel="Share your thoughts..",
    createPlaceholder="What are you thinking about..",
  } = props;
  const [formData, setFormData] = useState({
    content: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthenticated } = useContext(UserContext)

  const handleOnChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value})
  }

  const handleOnSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault()
    const payload = {
      content: formData.content,
      appName: appName,
      modelName: modelName,
      entityId: entityId,
    }
    await ThreadAPI.create(payload)
    setFormData({content: ''})
    setIsLoading(false)
    onSuccess()
  }

  return (
    <>
      {isAuthenticated ? (
        <CardContainer 
          className="p-4 bg-white"
          body={
            <form onSubmit={handleOnSubmit}>
              <Textarea
                label={createLabel}
                name="content"
                labelPlacement="outside"
                placeholder={createPlaceholder}
                className="w-full"
                onChange={handleOnChange}
                disabled={isLoading}
                value={formData.content}
              />
              <div className="flex">
                <Button className="mt-2" color="primary" type="submit" auto>
                  {isLoading ? <Spinner color="white" /> : <>Share it!</>}
                </Button>

              </div>
            </form>
          }
          
        />
      ) : (
        <LoginSuggestion />
      )}
    </>
  )
}
